import React from 'react';

// Custom styles for MovingText component
const styles = `
@import url('https://fonts.googleapis.com/css2?family=Milonga&display=swap');

.moving-text-section {
    background-color: rgba(47, 75, 32, 0.07);
    padding: 25px 0;
    overflow: hidden;
    position: relative;
}

.moving-text-container {
    display: flex;
    width: max-content;
    animation: scrollText 45s linear infinite;
}

.moving-text {
    font-family: 'Milonga', cursive;
    font-size: 2rem;
    font-weight: 400;
    font-style: normal;
    color: #2F4B20;
    white-space: nowrap;
    padding-right: 80px;
    letter-spacing: 0.5px;
    -webkit-text-stroke: 1px #2F4B20;
    text-stroke: 1px #2F4B20;
    paint-order: stroke fill;
}

@keyframes scrollText {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .moving-text-section {
        padding: 22px 0;
    }
    
    .moving-text {
        font-size: 1.8rem;
        padding-right: 70px;
    }
}

@media (max-width: 991.98px) {
    .moving-text-section {
        padding: 20px 0;
    }
    
    .moving-text {
        font-size: 1.6rem;
        padding-right: 60px;
    }
    
    .moving-text-container {
        animation-duration: 40s;
    }
}

@media (max-width: 767.98px) {
    .moving-text-section {
        padding: 18px 0;
    }
    
    .moving-text {
        font-size: 1.4rem;
        padding-right: 50px;
    }
    
    .moving-text-container {
        animation-duration: 35s;
    }
}

@media (max-width: 575.98px) {
    .moving-text-section {
        padding: 15px 0;
    }
    
    .moving-text {
        font-size: 1.2rem;
        padding-right: 40px;
    }
    
    .moving-text-container {
        animation-duration: 32s;
    }
}

@media (max-width: 400px) {
    .moving-text-section {
        padding: 12px 0;
    }
    
    .moving-text {
        font-size: 1rem;
        padding-right: 35px;
    }
    
    .moving-text-container {
        animation-duration: 30s;
    }
}
`;

const MovingText = () => {
    const text = "Through our curiosity-led, Hygge-inspired approach, children leave Zubis Nursery confident, capable, and prepared for the next stages of their life.";

    return (
        <>
            <style>{styles}</style>
            <section className="moving-text-section">
                <div className="moving-text-container">
                    {/* Duplicate text for seamless loop */}
                    <span className="moving-text">{text}</span>
                    <span className="moving-text">{text}</span>
                    <span className="moving-text">{text}</span>
                    <span className="moving-text">{text}</span>
                </div>
            </section>
        </>
    );
};

export default MovingText;
